import { DEFAULT_LANGUAGE } from "../i18n/translations";
import { getLanguageFromPath, stripLanguageFromPath } from "../i18n/LanguageProvider";

/**
 * Data the server already rendered into the page (window.__LIDERE_INITIAL_DATA__).
 * It is only valid for the URL it was rendered for, so every lookup checks language and path.
 */
function readInitialData() {
    if (typeof window === "undefined") return null;

    const data = window.__LIDERE_INITIAL_DATA__;

    return data && typeof data === "object" ? data : null;
}

export function getInitialData(key, { ignorePath = false } = {}) {
    const data = readInitialData();

    if (!data || data[key] === undefined || data[key] === null) return null;

    const pathname = window.location.pathname;

    if (data.language !== getLanguageFromPath(pathname)) return null;
    if (!ignorePath && data.path !== stripLanguageFromPath(pathname)) return null;

    return data[key];
}

/** Languages search engines may index; everything else is served with "noindex". */
export function getIndexableLanguages() {
    const languages = readInitialData()?.seo?.indexableLanguages;

    return Array.isArray(languages) && languages.length > 0 ? languages : [DEFAULT_LANGUAGE];
}

export function getProfileIndexMode() {
    return readInitialData()?.seo?.profileIndexMode === "with_sources" ? "with_sources" : "all";
}

/** Path (without language) the server rendered, used to drop its JSON-LD after a client navigation. */
export function getInitialPath() {
    const data = readInitialData();

    return data ? `/${data.language}${data.path === "/" ? "" : data.path}` : "";
}
